<template>
    <div class="adminDeviceSidebarNew">
      <div class="sidebar-list">
        <div class="sidebarViewBox">
          <!-- 侧栏查看账号列表 -->
          <div>
            <div class="titletype">{{ $t('account.account_number') }}</div>
            <button type="button" class="btn-view" :class="{ 'activeBtnView': currentBtnViewIndex == 1 }"
            @click="enterUsrBox({ index: 1 })">
              <span class="ico-view ico-view-device" >
                <i class="iconfont icon-a-mingchengyonghushuxingshuangren3 iconstyle"></i>
              </span>
              <!-- <span class="text-view">{{ $t('account.accountList') }}</span> -->
              <el-tooltip effect="dark" :disabled="!tooltipFlag"  :content="$t('account.accountList')" placement="right">
              <span @mouseenter="visibilityChange($event)" class="text-view" sty>{{ $t('account.accountList') }}</span>
            </el-tooltip>
            </button>
          </div>
          <!-- 侧栏查看权限列表 -->
          <div v-if="this.$store.state.user.role ==1">
            <div class="titletype">{{ $t('account.Role_authority') }}</div>
            <button type="button" class="btn-view" :class="{ 'activeBtnView': currentBtnViewIndex == 2 }"
            @click="enterAuthorityBox({ index: 2 })">
              <span class="ico-view ico-view-datalogger">
                <i class="iconfont icon-a-mingchengyonghushuxingyuanjiao2"></i>
              </span>
              <!-- <span class="text-view">{{ $t('account.authority_Management') }}</span> -->
              <el-tooltip effect="dark" :disabled="!tooltipFlag"  :content="$t('account.authority_Management')" placement="right">
              <span @mouseenter="visibilityChange($event)" class="text-view" sty>{{ $t('account.authority_Management') }}</span>
            </el-tooltip>
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  // import { mapGetters } from 'vuex';
  export default {
    // components: {},
    props: {

    },
    data () {
      return {
        tooltipFlag: false,
       // 当前选中列表查看索引(默认显示设备总列表)
      currentBtnViewIndex: 1,

      };
    },
    computed: {

    },
    watch: {

    },
    created () {},
    methods: {
            // tooltip的可控（解决文字过长的处理）
            visibilityChange(event) {
      const ev = event.target;
      const ev_weight = ev.scrollWidth; // 文本的实际宽度
      const content_weight = ev.clientWidth; // 文本的可视宽度
      if (ev_weight > content_weight) {
        // 文本宽度 > 实际内容宽度  -->内容溢出,则显示悬浮
        this.tooltipFlag = true;
      } else {
        // 否则为未溢出，不显示悬浮
        this.tooltipFlag = false;
      }
    },
        enterUsrBox(info){
            this.$emit('tabUsrChange-event', info.index);
            this.currentBtnViewIndex =info.index
        },
        enterAuthorityBox(info){
            this.$store.commit("saveUsrPermission",1)
            this.$emit('tabUsrChange-event', info.index);
            this.currentBtnViewIndex =info.index
        },
  
    },
  };
  </script>
  <style lang="less" scoped>
  .adminDeviceSidebarNew {
  
    // 滚动条
    ::-webkit-scrollbar {
      width: 0px;
      background-color: transparent;
    }
  
    // 弹窗滚动条
    // .dialogModalNew {
    //   ::-webkit-scrollbar {
    //     width: 3px;
    //     height: 3px;
    //     background-color: transparent;
    //   }
    // }
    .btn {
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 14px;
      cursor: pointer;
    }
  
    .btn-dark {
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      border: none;
    }
  
    .btn-light {
      background: transparent;
      color: @primaryTextColor;
      border: 1px solid @primaryTextColor;
    }
  
    .sidebar-list {
      box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.2);
      height: 100%;
      padding: 0 29px;
      background-color: rgb(34, 45, 53);
      color: #ffffff;
      font-size: 16px;
      padding-top: 20px;
      position: relative;
      // 解决侧栏列表滚动问题
      display: flex;
      flex-direction: column;
  
      // 侧栏加载更多
      .sidebarLoadmore {
        width: 206px;
        line-height: 50px;
        text-align: center;
        font-size: 14px;
        color: rgba(51, 255, 182, 1);
        cursor: pointer;
  
        // 加载数据时遮罩
        // /deep/.el-loading-mask {
        //   background-color: rgb(34, 45, 53, .5);
        // }
        /deep/.el-loading-spinner i {
          color: @primaryTextColor;
          font-size: 18px;
        }
  
        // /deep/.el-loading-spinner .path {
        //   stroke: @primaryTextColor;
        // }
      }
  
      .sidebartableloding {
  
        // 加载数据时遮罩
        /deep/.el-loading-mask {
          height: 100vh;
          background-color: rgb(34, 45, 53, .5);
        }
  
        /deep/.el-loading-spinner {
          top: 10vh;
          margin-top: 0px;
        }
  
        /deep/.el-loading-spinner i {
          color: @primaryTextColor;
          font-size: 18px;
        }
      }
  
      .sidebarViewBox {
        .titletype{
          font-size: 12px;
          color: #ADB9C0;
          padding-bottom: 16px;
        }
        // 侧栏查看设备列表
        // .ico-view-device {
        //   background: linear-gradient(180deg, rgba(79, 160, 247, 1) 0%, rgba(50, 125, 245, 1) 100%);
        // }
  
        // .ico-view-datalogger {
        //   background: linear-gradient(180deg, rgba(146, 230, 124, 1) 0%, rgba(100, 194, 101, 1) 100%);
        // }
  
        // .ico-view-follow {
        //   background: linear-gradient(180deg, rgba(241, 183, 68, 1) 0%, rgba(241, 152, 55, 1) 100%);
        // }
  
        // .ico-view-project {
        //   background: linear-gradient(180deg, rgba(240, 147, 255, 1) 0%, rgba(169, 63, 171, 1) 100%);
        // }
  
        .ico-view {
          display: inline-block;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          border-radius: 5px;
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
          // margin-top: 2px;
          i {
            color: #ffffff;
            font-size: 20px;
          }
        }
  
        .text-view {
          color: rgba(255, 255, 255, 0.7);
          font-size: 16px;
          margin-left: 10px;
          text-align: left;
          overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        }
  
        .btn-view {
          width: 206px;
          // height: 40px;
          border-radius: 6px;
          background: rgba(34, 45, 53, 1);
          display: flex;
          justify-content: flex-start;
          // align-items: center;
          padding: 8px 10px;
          margin-bottom: 20px;
          cursor: pointer;
  
          &.activeBtnView {
            background: rgba(43, 56, 66, 1);
            i{
              color: @primaryTextColor;
            }
  
            .text-view {
              color: @primaryTextColor;
            }
          }
        }
  
      }
  
      // 添加按钮
      /deep/.el-button {
        display: block;
        width: 100%;
        height: 38px;
        border: none;
        border-radius: 6px;
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 16px;
        margin-bottom: 20px;
        padding: 0;
      }
  
      /deep/.el-button .el-icon-add:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../assets/img/general/Icon_Device_Add.png) no-repeat;
        background-size: 100%;
        background-position: center;
      }
  
      /deep/.el-icon-add {
        vertical-align: middle;
      }
  
      // 分割线
      .spliteline {
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.2);
        margin-bottom: 20px;
      }
  
      // 搜索框
      /deep/.search-input.el-input {
        display: block;
        font-size: 16px;
      }
  
      /deep/.search-input.el-input .el-input__inner {
        margin-bottom: 20px;
        height: 42px;
        padding-left: 42px;
        color: #ffffff;
      }
  
      /deep/.search-input .el-input__inner {
        background-color: transparent;
        border-radius: 0;
        border: 1px solid @primaryTextColor;
      }
  
      /deep/.search-input .el-input__inner:hover {
        border: 1px solid @primaryTextColor;
      }
  
      /deep/.search-input .el-input__inner:focus {
        border: 1px solid @primaryTextColor;
      }
  
      // .el-input__suffix
      /deep/.search-input .el-input__prefix {
        left: 14px;
        height: auto;
      }
  
      /deep/.search-input .el-input__icon {
        color: #ffffff;
        font-size: 20px;
        line-height: 42px;
        margin-left: -6px;
      }
  
      /deep/.search-input input::-webkit-input-placeholder {
        font-weight: 100;
        color: #ffffff;
        font-size: 14px;
      }
  
      /deep/.search-input input::-moz-input-placeholder {
        font-weight: 100;
        color: #ffffff;
        font-size: 14px;
      }
  
      /deep/.search-input input::-ms-input-placeholder {
        font-weight: 100;
        color: #ffffff;
        font-size: 14px;
      }
  
      // .searchbox {}
      // 项目列表
      /deep/.el-table .cell {
        // padding: 0 40px 0 0;
        padding: 0px;
      }
  
      /deep/.el-table__expand-icon>.el-icon {
        margin-top: -6px;
      }
  
      /deep/.el-table .cell,
      /deep/.el-table th div {
        overflow: inherit;
      }
  
      /deep/.el-table__body .el-table__row .el-table_1_column_2 .cell.el-tooltip {
        font-size: 16px;
        text-align: right;
      }
  
      /deep/.el-table__body .el-table__row .el-table_2_column_4 .cell.el-tooltip {
        font-size: 16px;
        text-align: right;
      }
  
      /deep/.el-table__body .el-table__row.expanded .cell.el-tooltip {
        color: @primaryTextColor;
      }
  
      /deep/.el-table__body .el-table__row.expanded .cell.el-tooltip {
        color: @primaryTextColor;
      }
  
      /deep/.el-table__body .el-table__row.expanded .el-table__expand-icon>.el-icon {
        color: @primaryTextColor;
      }
  
      /deep/.el-table,
      .el-table__expanded-cell {
        background: transparent;
        border: none;
        color: #ffffff;
      }
  
      /deep/.el-table--border::after,
      .el-table--group::after {
        width: 0;
      }
  
      /deep/.el-table__expanded-cell[class*=cell] {
        padding: 0;
      }
  
      /deep/.el-table--scrollable-x .el-table__body-wrapper:last-child {
        overflow-x: hidden;
      }
  
      /deep/.el-table .cell.el-tooltip {
        text-align: right;
        padding: 0;
      }
  
      /deep/.el-table th,
      .el-table tr {
        background-color: rgb(34, 45, 53);
        border: none;
      }
  
      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        border: none;
      }
  
      /deep/.el-table--enable-row-transition .el-table__body td {
        border: none;
      }
  
      /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
        background-color: rgb(34, 45, 53);
        border: none;
      }
  
      /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
        background-color: rgb(34, 45, 53);
        border: none;
      }
  
      /deep/.el-table,
      .el-table__expanded-cell {
        background-color: rgb(34, 45, 53);
        border: none;
      }
  
      /deep/.el-table__row.hover_row {
        border: none;
      }
  
      /deep/.el-table__body-wrapper .el-table__expand-icon>.el-icon {
        color: #ffffff;
      }
  
      .viewbox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
  
        // width: 247px;
        /deep/.el-select .el-input .el-input__icon.el-icon-circle-close {
          margin-top: 5px;
        }
  
        .totalNum {
          display: inline-block;
          height: 34px;
          line-height: 34px;
          font-size: 14px;
          max-width: 206px;
        }
  
        .screen {
          display: flex;
          justify-content: space-between;
          align-items: center;
          // width: 50px;
          max-width: 50%;
          min-width: 42%;
          height: 34px;
          line-height: 34px;
          position: relative;
  
          .shaixuan {
            display: inline-block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            line-height: 34px;
            background: #202D35;
            color: #ffffff;
            font-size: 16px;
            z-index: 1;
            cursor: pointer;
          }
  
          .el-select {
            position: absolute;
            top: 0;
            left: 0;
          }
  
          /deep/.el-input__inner {
            background: #202D35;
            border: none;
            padding: 0px 5px;
            font-size: 14px;
            color: #ffffff;
          }
  
          /deep/.el-input__prefix,
          /deep/.el-input__suffix {
            top: -4px;
            // right: -20px;
            right: 0px;
            background: #202D35;
          }
  
          /deep/.el-icon-arrow-up:before {
            content: '';
            display: inline-block;
            width: 20px;
            height: 24px;
            background: url(../../../assets/img/general/Icon_Down.png);
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            transform: rotate(180deg);
          }
  
          /deep/.el-select .el-input .el-select__caret.is-reverse {
            transform: rotate(180deg);
          }
        }
  
        .mode {
          display: flex;
          justify-content: space-between;
          align-items: center;
  
          .modeleft {
            background-image: url(../../../assets/img/general/Icon_Mode_Dark_L.png);
          }
  
          .showmodeleft {
            background-image: url(../../../assets/img/general/Icon_Mode_Light_L.png);
          }
  
          .moderight {
            background-image: url(../../../assets/img/general/Icon_Mode_Dark_R.png);
          }
  
          .showmoderight {
            background-image: url(../../../assets/img/general/Icon_Mode_Light_R.png);
          }
  
          .modecell {
            width: 34px;
            height: 34px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
          }
        }
      }
  
      // 关注
      .device-item-follow {
        // display: none;
        position: absolute;
        top: 0px;
        right: 0px;
        width: 40px;
        height: 40px;
        border-radius: 0 0 0 100%;
  
        // background:#858F97;
        // 是否关注
        .followno {
          width: 20px;
          height: 20px;
          background-image: url(../../../assets/img/general/Icon_Operate_Follow_Light.png);
        }
  
        .followyes {
          width: 24px;
          height: 24px;
          background-image: url(../../../assets/img/general/Icon_Operate_Follow_Dark.png);
        }
  
        .followbase {
          display: inline-block;
          position: absolute;
          top: 4px;
          right: 4px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          vertical-align: middle;
        }
      }
  
      .device-item {
        position: relative;
        width: 100%;
        height: 124px;
        background: url(../../../assets/img/general/device-item-bgi.jpg) no-repeat;
        background-size: cover;
        background-position: center;
        margin-bottom: 25px;
        cursor: pointer;
  
        .device-item-mask {
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          width: 100%;
          height: 62px;
          background: rgba(34, 45, 53, 0.8);
        }
  
        .device-item-info {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 62px;
          padding: 0 15px;
          color: rgba(255, 255, 255, 0.7);
          font-size: 18px;
          text-align: left;
  
          .device-item-namebox {
            display: block;
            margin-top: 6px;
            width: 100%;
            text-align: left;
  
            .device-item-name {
              display: inline-block;
              width: 70%;
              font-family: Microsoft YaHei;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
  
              &.activePro {
                color: @primaryTextColor;
              }
            }
          }
  
          .device-item-idbox {
            display: block;
            margin-top: 2px;
            width: 100%;
  
            .device-item-id {
              display: inline-block;
              width: 102%;
              font-family: Microsoft YaHei;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
      }
  
      .device-item-easy {
        width: 100%;
        height: 55px;
        border-bottom: 1px solid #424E56;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
  
        .device-item-namebox {
          display: block;
          margin-top: 6px;
          text-align: left;
          width: 85%;
  
          .device-item-name {
            display: inline-block;
            width: 70%;
            font-family: Microsoft YaHei;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
  
            &.activePro {
              color: @primaryTextColor;
            }
          }
        }
  
        .device-item-follow {
          .followbase {
            top: 6px;
          }
        }
      }
  
      .device-item:hover,
      .device-item-easy:hover {
        .showFollow {
          display: inline-block;
        }
  
        .device-item-follow {
          background: #858F97;
        }
      }
  
      .status-icon {
        width: 15px;
        height: 15px;
        margin-right: 10px;
        vertical-align: text-top;
      }
  
      .project-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: rgba(34, 45, 53, 1);
        box-shadow: 0px 4px 23px rgba(58, 77, 90, 0.3) inset;
        z-index: 3;
  
        .project-create,
        .project-manage {
          display: flex;
          justify-content: center;
          align-items: center;
        }
  
        /deep/button {
          display: block;
          width: 100%;
          height: 56px;
          line-height: 56px;
          border: none;
          border-radius: 0px;
          background: rgba(34, 45, 53, 1);
          color: #ffffff;
          font-size: 14px;
          padding: 0px;
          margin-bottom: 0px;
          box-shadow: 0px 4px 23px rgba(58, 77, 90, 0.3) inset;
          cursor: pointer;
  
          i {
            font-size: 24px;
            color: @primaryTextColor;
            margin-right: 8px;
            // vertical-align: middle;
          }
        }
  
        .project-line {
          width: 0.1px;
          height: 30px;
          border-width: 0.1px;
          border-style: solid;
          border-image-source: radial-gradient(57% 44.45% at 50% 50%, rgba(255, 255, 255, 1) 0%, rgba(34, 45, 53, 0) 100%);
          border-image-slice: 1;
          border-image-outset: 0.1px;
        }
      }
    }
  
    .el-dropdown-pro {
      width: 100%;
      max-width: 206px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
  
      .showlabel {
        width: 100%;
        max-width: 247px;
        color: rgba(255, 255, 255, 1);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0px;
  
        .countbox {
          width: 90%;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
  
          .pnamebox {
            // display: block;
            // text-align: left;
            max-width: 65%;
            // padding-top: 5px;
            margin-right: 5px;
  
            .pname {
              display: inline-block;
              padding-top: 5px;
              width: 100%;
              font-family: Microsoft YaHei;
              font-size: 16px;
              font-weight: bold;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
      }
    }
  
    // 设备列表
    .proDeviceList {
      /deep/.el-table__empty-block {
        height: auto;
      }
  
      // 设备管理=》侧栏项目
      .group-box {
        position: absolute;
        // left:-20px;
        margin-top: -12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 206px;
  
        .group-label {
          display: flex;
          justify-content: flex-start;
          // justify-content: space-between;
          width: 100%;
          text-align: left;
  
          // margin-left: -20px;
          i {
            font-size: 20px;
          }
  
          .label-name {
            display: inline-block;
            width: 60%;
            // 处理分组名称过长
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            cursor: pointer;
            margin-left: 10px;
          }
  
          .label-num {
            display: inline-block;
            text-align: right;
            // margin-left: 5px;
            // 计数值超大时
            // line-height: 1;
          }
  
          // 激活
          &.activeGroup {
            color: @primaryTextColor;
          }
        }
      }
    }
  
    // 新建项目(上传图片)
    .upload-contents {
      border-radius: 6px;
      border: 1px dashed rgba(255, 255, 255, 0.5);
      padding: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
  
      .upload-buttonEquipment {
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 6px 16px 6px 10px;
        color: rgba(255, 255, 255, 0.5);
        font-size: 14px;
  
        i {
          color: rgb(56, 165, 118);
          font-size: 32px;
        }
      }
  
      .upload-input {
        display: none;
      }
    }
  
    //控制权限里面的样式
    .editControl {
      margin-top: -20px;
      margin-bottom: -2px;
      display: flex;
      flex: 1;
      flex-direction: column;
  
      // 滚动条
      // ::-webkit-scrollbar {
      //   width: 3px;
      //   background-color: transparent;
      // }
      .searchprotocol {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 15px;
  
        .searchName {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          width: 130px;
          color: rgba(255, 255, 255, 0.7);
          font-size: 14px;
        }
  
        .el-select {
          margin-left: 0px;
          width: 500px;
          // overflow: auto;
        }
      }
  
      .personProtocol,
      .adminProtocol {
        display: flex;
        flex-direction: row;
        min-height: 180px;
  
        // border: 1px solid #d9d9d9;
        .contentLeft {
          flex: 1;
          // margin: auto;
          font-family: "Times New Roman", "Microsoft YaHei";
          font-size: 16px;
          letter-spacing: 1.5px;
          height: 100%;
          width: 130px;
          // padding: 10px;
          color: rgba(255, 255, 255, 0.7);
  
          .top {
            // height: 25px;
            // line-height: 25px;
            // text-align: center;
            // border-bottom: 1px solid #d9d9d9;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            text-align: right;
            font-size: 14px;
  
            /deep/.el-checkbox__label {
              color: rgba(255, 255, 255, 1);
              // width: 50px;
              width: auto;
              font-size: 14px;
            }
  
            /deep/.el-checkbox__inner {
              width: 14px;
              height: 14px;
              border-radius: 4px;
              border: 1px solid rgba(190, 190, 190, 1);
              background: rgba(255, 255, 255, 1);
            }
  
            /deep/.el-checkbox__inner:hover,
            /deep/.el-checkbox__inner:focus {
              border: 1px solid rgba(51, 255, 182, 1);
            }
  
            /deep/.el-checkbox {
              margin-right: 10px;
              margin-top: 30px;
            }
  
            /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
              border: 1px solid rgba(51, 255, 182, 1);
              background: @primaryTextColor;
            }
          }
        }
  
        .contentRight {
          flex: 7;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
  
          // .top {
          //   height: 25px;
          //   line-height: 25px;
          //   text-align: center;
          //   border-bottom: 1px solid #d9d9d9;
          //   /deep/.el-checkbox__label {
          //     color: rgba(255, 255, 255, 1);
          //     width: 50px;
          //   }
          //   /deep/.el-checkbox__inner:hover, 
          //   /deep/.el-checkbox__inner:focus {
          //     border: 1px solid @primaryTextColor;
          //   }
          //   /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
          //     background: @primaryTextColor;
          //     border: 1px solid @primaryTextColor;
          //   }
          // }
          .noData {
            margin: 40px auto;
            font-size: 14px;
            color: #909399;
          }
  
          .protoclContents {
            flex: 1;
            max-height: 300px;
            overflow: auto;
  
            .checkboxUnit {
              // font-family: "微软雅黑";
              // padding-left: 6px;
              padding: 10px;
              margin: 0;
  
              // border-right: 0.5px solid #eee;
              /deep/.el-checkbox__label {
                color: rgba(255, 255, 255, 1);
                font-size: 14px !important;
                padding-left: 5px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 136px !important;
                padding-top: 5px;
              }
  
              /deep/.el-checkbox__inner:hover,
              /deep/.el-checkbox__inner:focus {
                border: 1px solid rgba(51, 255, 182, 1);
              }
  
              /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
                border: 1px solid rgba(51, 255, 182, 1);
                background: @primaryTextColor;
              }
            }
          }
  
          /deep/.el-checkbox__inner {
            width: 14px;
            height: 14px;
            border-radius: 4px;
            border: 1px solid rgba(190, 190, 190, 1);
            background: rgba(255, 255, 255, 1);
          }
  
          /deep/ .el-checkbox__inner::after {
            top: 1px;
            left: 4px;
          }
  
          // 滚动条
          ::-webkit-scrollbar {
            width: 3px;
            height: 3px;
            background-color: transparent;
          }
        }
      }
  
      .adminProtocol {
        margin-top: 15px;
      }
    }
  }
  
  // 滚动条
  // ::-webkit-scrollbar {
  //   width: 0px;
  //   background-color: transparent;
  // }
  
  // #操作结果提示#
  .showresultbox {
    display: flex;
    flex-direction: column;
    align-items: center;
  
    // 图标
    .showsuccess {
      border: 3px solid rgba(37, 255, 174, 1);
      background-color: rgba(19, 195, 156, 1);
      background-image: url(../../../assets/img/general/Icon_Finished.png);
      background-size: 70px 70px;
    }
  
    .showfail {
      border: 3px solid rgba(246, 189, 189, 1);
      background: rgba(251, 75, 75, 1);
      background-image: url(../../../assets/img/general/Icon_Failed.png);
      background-size: 120px 120px;
    }
  
    .showbase {
      width: 100px;
      height: 100px;
      box-sizing: border-box;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 50%;
    }
  
    // 提示
    .showresulttext {
      font-weight: bold;
      font-size: 18px;
      margin-top: 20px;
      margin-bottom: 30px;
      color: rgba(255, 255, 255, 1);
    }
  
    // 操作
    .showoperate {
      text-align: center;
    }
  
    .showresultbtn {
      width: 102px;
      height: 30px;
      margin-top: 10px;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      font-size: 14px;
    }
  }
  </style>
  <style lang="less">
  // 筛选下拉菜单
  .select-search-pro {
    width: 200px;
    background: #222D35;
    font-family: Microsoft YaHei;
    border-radius: 6px;
    ;
    box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
    border: none;
  
    .el-select-dropdown__wrap {
      max-height: 546px;
    }
  
    .el-select-group__wrap:not(:last-of-type)::after {
      height: 0px;
    }
  
    .el-select-group__title {
      padding-left: 16px;
      font-size: 14px;
      color: #ffffff;
      border-bottom: 1px solid #424E56;
      line-height: 39px;
      margin-top: 10px;
    }
  
    .el-select-dropdown__item {
      padding-left: 16px;
      font-size: 14px;
      text-align: left;
      background: #222D35;
      color: #ffffff;
      font-family: Microsoft YaHei;
    }
  
    .el-select-group__wrap {
      padding-bottom: 0px;
    }
  
    // .el-select-dropdown__item.hover {
    // }
    .el-select-dropdown__item:hover {
      background: #222D35;
      color: #ffffff;
    }
  
    .el-select-dropdown__item.selected:before {
      content: "";
      display: inline-block;
      height: 16px;
      width: 16px;
      background: url(../../../assets/img/general/Icon_Duihao.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      margin-right: 5px;
      position: absolute;
      top: 6px;
      right: 12px;
    }
  }
  
  // 切换项目的悬浮框
  .el-dropdownmenu-pro {
    // overflow: hidden;
    background: #202D35;
    color: #ffffff;
    border-radius: 6px;
    border: none;
    padding: 10px 0px;
    // min-width: 100px;
    // min-height: 30px;
    // 分页加载
    max-height: 300px;
  
    .el-dropdown-menu__item {
      background: #202D35;
      color: #ffffff;
      border: none;
      font-size: 16px;
    }
  
    .el-dropdown-menu__item.selected,
    .el-dropdown-menu__item:hover,
    .el-dropdown-menu__item:focus {
      background: #202D35;
      color: @primaryTextColor;
      border: none;
    }
  
    .el-dropdown-menu__item:hover {
      background: @primaryColorTransparency30;
      color: rgba(255, 255, 255, 1);
    }
  
    .el-dropdown-menu__item:not(:last-child) {
      border: none;
    }
  
    .popper__arrow {
      display: none;
    }
  
    &.el-popper[x-placement^=right] {
      margin-left: 5px;
    }
  
    // 滚动条
    ::-webkit-scrollbar {
      width: 3px;
      height: 3px;
      background-color: transparent;
    }
  }
  
  .selectClearNew {
  
    // 下拉选中清除按钮
    .el-icon-circle-close:before {
      content: "";
      display: inline-block;
      height: 16px;
      width: 16px;
      background: url(../../../assets/img/general/Icon_SelectClear.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      // position: absolute;
      // top: 8px;
      // right: 16px;
    }
  }
  </style>
  